import closeArrowGrey from "../resources/images/buttonImages/closeSidebar/LeftArrowGrey.png"
import openMenuGrey from "../resources/images/buttonImages/openSidebar/MenuGrey.png"
import closeArrowRed from "../resources/images/buttonImages/closeSidebar/LeftArrowRed.png"
import openMenuRed from "../resources/images/buttonImages/openSidebar/MenuRed.png"
import closeArrowTeal from "../resources/images/buttonImages/closeSidebar/LeftArrowTeal.png"
import openMenuTeal from "../resources/images/buttonImages/openSidebar/MenuTeal.png"
import closeArrowPurple from "../resources/images/buttonImages/closeSidebar/LeftArrowPurple.png"
import openMenuPurple from "../resources/images/buttonImages/openSidebar/MenuPurple.png"
import closeArrowBlue from "../resources/images/buttonImages/closeSidebar/LeftArrowBlue.png"
import openMenuBlue from "../resources/images/buttonImages/openSidebar/MenuBlue.png"
import closeArrowGreen from "../resources/images/buttonImages/closeSidebar/LeftArrowGreen.png"
import openMenuGreen from "../resources/images/buttonImages/openSidebar/MenuGreen.png"
import closeArrowOrange from "../resources/images/buttonImages/closeSidebar/LeftArrowOrange.png"
import openMenuOrange from "../resources/images/buttonImages/openSidebar/MenuOrange.png"

export const BUTTONS = {

    defaultButtons: {
        openMenu: openMenuGrey,
        closeMenu: closeArrowGrey
    },
    redStyleButtons: {
        openMenu: openMenuRed,
        closeMenu: closeArrowRed
    },
    tealStyleButtons: {
        openMenu: openMenuTeal,
        closeMenu: closeArrowTeal
    },
    purpleStyleButtons: {
        openMenu: openMenuPurple,
        closeMenu: closeArrowPurple
    },
    blueStyleButtons: {
        openMenu: openMenuBlue,
        closeMenu: closeArrowBlue
    },
    greenStyleButtons: {
        openMenu: openMenuGreen,
        closeMenu: closeArrowGreen
    },
    orangeStyleButtons: {
        openMenu: openMenuOrange,
        closeMenu: closeArrowOrange
    }
}